<template>
    <div class="title">
        <h4>
            {{title}}
        </h4>
    </div>
</template>

<script>
    export default {
        name: 'HomeTitle',
        props: ['title']
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/custom/vars';
    .title {
        border-bottom: 8px solid $omyfu-red;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeTitleComponent.vue